import { useMemo } from "react";
import { useLocation, useRouteMatch } from "react-router-dom";

export function useSearchParams() {
	const { search } = useLocation();

	return useMemo(() => new URLSearchParams(search), [search]);
}

export function useTryParseRouteId(str: string) {
	return useMemo(() => {
		const parsed = parseInt(str);
		return isNaN(parsed) ? 0 : parsed;
	}, [str]);
}

export const useCustomRouteMatch = () => {
	const match = useRouteMatch();

	const url = match.url === "/" ? "" : match.url;
	const path = match.path === "/" ? "" : match.path;

	return { url, path };
};
